(ns authentication.views
  (:require
   [reagent.core :as r]
   [very.re-frame.core :as rf :refer [<sub >evt]]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]
   [css.form :as form]
   [css.icons :as icons]
   [main.common :as common]
   [css.typography :as typo]
   [css.vars :as vars]
   [cljss.core :as cljss]
   [util.core :refer [long-str] :as util]
   [branding.views :as branding])
  (:require-macros
   [logging.core :refer [log]]))

(defn- get-input-val [state key evt]
  (assoc state key (-> evt .-target .-value)))

(defn- valid-password? [password]
  (boolean (re-find #"^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}" password)))

(defstyled message-s :p
  {:color (with-meta #(if % vars/red (get-theme :primary)) :error?)
   :margin-bottom "1rem"
   :font-weight "bold"})

(defstyled unauth-s :div
  {:display "grid"
   :min-height "100vh"
   :grid-template-rows "[header-start] min-content [header-end body-start] 1fr [body-end footer-start] min-content [footer-end]"})

(defstyled content-container-s :div
  {:max-width "82rem"
   :width "100%"
   :padding "0 1rem"
   :margin "0 auto"})

(defstyled unauth-header-s :header
  {:height "8rem"
   :display "flex"
   :flex-direction "row"
   :align-items "center"
   :border-bottom (str "1px solid #F6F6F6")})

(defstyled unauth-footer-s :footer
  {:width "100%"
   :background (get-theme :tertiary)
   :color "white"
   :padding "2rem 0"
   :margin-top "8rem"})

(defstyled form-wrapper-s :div
  {:max-width "540px"
   :width "100%"
   :margin "0 auto"
   :padding "8rem 1rem 0"})

(defstyled form-subtitle-s :h3
  {:font-size "1.33rem"
   :color (get-theme :primary)
   :font-weight "bold"})

(defstyled tel-s :a
  {:color (get-theme :primary)
   :text-decoration "none"
   :&:hover {:text-decoration "underline"}})

(defstyled form-title-s :h1
  {:color vars/title
   :font-size "2.27rem"
   :font-weight 300
   :margin "1.25rem 0 2.5rem"})

(defstyled form-item-s :div
  {:margin-bottom "2rem"
   :&:last-child {:margin-bottom "0"}})

(defstyled help-text-s :div
  {:color "#666"
   :line-height "1.6rem"
   :margin-bottom "2rem"})

(defstyled footer-div-s :div
  {:margin "1rem 0"
   :font-size "12px"
   :line-height "18px"})

(defstyled footer-p-s :p
  {:margin "1rem 0"
   :font-size "12px"
   :line-height "18px"})

(defstyled divider-s :div
  {:border-right "1px solid white"
   :height "14px"
   :margin "0 .5rem"})

(defstyled footer-a-s :a
  {:color "white"})

(defstyled row-s :div
  {:display "flex"
   :flex-direction "row"
   :align-items "center"})

(defstyled advisor-phone-s :a
  {:color (get-theme :primary)})

(defn unauth-header []
  [unauth-header-s
   [content-container-s
    [branding/logo]]])

(defn unauth-footer []
  [unauth-footer-s
   [branding/footer]])

(defn default-unauth-footer []
  [unauth-footer-s
   [content-container-s
    [branding/logo]
    [footer-p-s (long-str
                 "The content is developed from sources believed to be providing accurate information. "
                 "The information in this material is not intended as tax or legal advice. "
                 "It may not be used for the purpose of avoiding any federal tax penalties. "
                 "Please consult legal or tax professionals for specific information regarding your individual situation. "
                 "The opinions expressed and material provided are for general information, "
                 "and should not be considered a solicitation for the purchase or sale of any security.")]
    [footer-div-s
     [row-s
      [footer-a-s {:href "/"} "Privacy Policy"]
      [divider-s]
      [footer-a-s {:href "/"} "Important Disclosures"]]]
    [footer-p-s (long-str
                 "Securities offered through Cetera Advisor Networks LLC (doing insurance business in CA as "
                 "CFGAN Insurance Agency), Member FINRA/SIPC. Investment advisory services offered through CWM, "
                 "LLC, an SEC Registered Investment Advisor. Cetera Advisor Networks LLC "
                 "is under separate ownership from any other named entity. "
                 "Carson Institutional Alliance, a division of CWM, LLC, is a nationwide partnership of advisors.")]
    [footer-p-s (long-str
                 "This site is published for residents of the United States only. "
                 "Registered Representatives of Cetera Advisor Networks LLC may only "
                 "conduct business with residents of the states and/or jurisdictions "
                 "in which they are properly registered. Not all of the products and "
                 "services referenced on this site may be available in every state and "
                 "through every advisor listed. For additional information please "
                 "contact the advisor(s) listed on the site, visit the Cetera Advisor Networks LLC site at ") [footer-a-s {:href "http://www.ceteraadvisornetworks.com."} "http://www.ceteraadvisornetworks.com."]]
    [footer-p-s (long-str
                 "Copyright 2018 Carson Wealth Management. All rights reserved. "
                 "This content cannot be copied without express written consent of CWM, "
                 "LLC. Wealth Designed. Life Defined. is a registered trademark of CWM, "
                 "LLC and may not be duplicated.")]
    [footer-p-s (long-str
                 "Additional information about CWM, LLC and our advisors is "
                 "also available online at http://www.adviserinfo.sec.gov or "
                 "http://brokercheck.finra.org. You can view our firm’s information "
                 "on this website by searching for CWM, LLC or by our CRD number 155344.")]
    [footer-p-s
     [footer-a-s {:href "/"} "Terms of Use"]]]])

(defn signup-help [phone-number]
  [help-text-s
   [:div "Don't have a username and password?"]
   [:div "Please call your advisor. " (when phone-number [advisor-phone-s {:href (str "tel:+" phone-number)} phone-number])]])

(defn- message [form]
  (when (:message form)
    [message-s {:error? (:error? form)
                :data-test "login-message"}
     (:message form)]))

(defstyled password-requirement-s :li
  {:padding-bottom ".5rem"
   :font-size ".9rem"
   :&:last-child {:padding-bottom "2rem"}})

(defstyled special-char-s :span
  {:border (str "1px dashed " (get-theme :primary))
   :padding ".25rem"
   :margin-left ".5rem"})

(defn- password-complexity-requirements []
  [:ul
   [password-requirement-s "At least 1 lower case character"]
   [password-requirement-s "At least 1 upper case character"]
   [password-requirement-s "At least 1 number"]
   [password-requirement-s
    [:span "At least 1 special character"]
    [special-char-s "@ $ ! % * ? &"]]
   [password-requirement-s "At least 8 total characters"]])

(defstyled reveal-s :button
  {:border "none"
   :&:focus {:outline 0}
   :&:active {:outline 0}})

(defstyled password-reveal-s :div
  {:position "relative"})

(defn- password-reveal []
  (let [reveal? (r/atom false)]
    (fn [on-change]
      [password-reveal-s
       [form/input {:name "password"
                    :required true
                    :on-change on-change
                    :placeholder "Password"
                    :type (if @reveal? "text" "password")}]
       [reveal-s {:on-mouse-down #(reset! reveal? true)
                  :on-mouse-up #(reset! reveal? false)
                  :type "button"}
        [icons/eyecon]]])))

(defn invite []
  (let [state (r/atom {:error false})
        form-s (rf/subscribe [:authentication/form])
        client (rf/subscribe [:authentication/client])
        do-reset-password (fn []
                            (swap! state #(assoc % :error false))
                            (>evt [:set-password @state]))]
    (fn []
      [unauth-s
       [unauth-header]
       [form-wrapper-s
        [form-subtitle-s
         (if (:name @client)
           (str "Welcome, " (:name @client) ".")
           "Welcome.")]
        [form-title-s "Please provide a password."]
        [:form
         {:on-submit (fn [evt]
                       (.preventDefault evt)
                       (if (valid-password? (:password @state))
                         (do-reset-password)
                         (swap! state #(assoc % :error true))))}
         [message @form-s]
         [form-item-s
          [password-reveal #(do
                              (swap! state get-input-val :password %)
                              (swap! state assoc :error false))]]

         (if (:error @state)
           [message-s {:error? true} "Password does not meet the complexity requirements:"])

         [password-complexity-requirements]
         [form/button {:type "submit"
                       :margin "0 0 2rem"
                       :disabled (:submitting? @form-s)} "Create Password"]]]
       [unauth-footer]])))

(defstyled mfa-wrapper-s :div
  {:display "grid"
   :grid-template-columns vars/container-grid})

(defstyled mfa-s :div
  {:grid-column "content"})

(defstyled mfa-header-s :div
  {:margin "0 0 2rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:margin "0 0 2rem"}}})

(defn mfa-header [{:keys [title text]}]
  [mfa-header-s
   [typo/h1 {:text-align "center"} title]
   [typo/text {:text-align "center"
               :max-width "25rem"
               :line-height "1.875rem"
               :margin "auto"} text]])

(defstyled mfa-step-s :div
  {:box-shadow "1px 1px 3px rgba(0, 0, 0, 0.3)"
   :display "flex"
   :flex-direction "column"
   :align-items "center"
   :padding "5rem 3rem"
   :grid-column (with-meta #(or % "auto") :grid-column)
   ::cljss/media {[[:max-width "1100px"]]
                  {:box-shadow "none"
                   :padding "3rem 1rem"
                   :grid-column "span 1"}}})

(defstyled step-number-s :div
  {:font-size "1.375rem"
   :font-weight "bold"})

(defstyled step-title-s :div
  {:text-align "center"
   :font-size "1.125rem"
   :font-weight (with-meta #(or % "700") :font-weight)
   :line-height "1.6rem"
   :min-height "3.125rem"
   :margin (with-meta #(or % "1rem 0") :margin)})

(defstyled badge-s :a
  {:background-image (with-meta #(str "url(/assets/icons/badge--" % ".svg)") :logo)
   :background-repeat "no-repeat"
   :background-size "contain"
   :background-position "center"
   :display "block"
   :height "3.75rem"
   :width "100%"
   :margin (with-meta #(or % "0 0 3rem") :margin)})

(defstyled qr-code-s :img
  {:width "100%"
   :max-width "15rem"
   :height "auto"
   :margin "0 auto"})

(defstyled step-grid-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr 1fr"
   :grid-gap "2rem"
   :justify-content "center"
   ::cljss/media {[[:max-width "1100px"]]
                  {:grid-template-columns "1fr"}}})

(defstyled help-tab-s :button
  {:cursor "pointer"
   :background "none"
   :border "none"
   :padding "1.5rem"
   :font-size "1.125rem"
   :border-bottom (with-meta #(if %
                                (str "3px solid " (get-theme :primary))
                                (str "3px solid " vars/border-light)) :active?)
   :&:focus {:outline (str "1px dotted " (get-theme :primary))}})

(defstyled authy-screen-s :img
  {:margin "1rem 0"})

(defstyled step-body-s :div
  {:display "flex"
   :flex-direction "column"
   :align-items "center"
   :width "100%"})

(defstyled abs-label-s :div
  {:font-weight "bold"
   :font-size ".88rem"})

(defstyled back-button-s :button
  {:font-size "1.25rem"
   :font-weight "300"
   :display "flex"
   :align-items "center"
   :background "none"
   :border "none"
   :padding "0"
   :cursor "pointer"
   :border-bottom "1px solid transparent"
   :padding-bottom ".25rem"
   :transition "border .25s ease-in"
   :&:before {:display "inline-block"
              :background-image "url(/assets/icons/chevron.svg)"
              :background-position "left center"
              :background-repeat "no-repeat"
              :background-size "1rem"
              :margin-right ".5rem"
              :transform "rotate(90deg)"
              :content ""
              :width "1rem"
              :height "1rem"}
   :&:hover {:border-color (get-theme :primary)}})

(defn mfa-step [{:keys [number title grid-column]}]
  (let [this (r/current-component)]
    [mfa-step-s {:grid-column (if grid-column grid-column "auto")}
     [step-number-s number]
     [step-title-s title]
     (into [step-body-s] (r/children this))]))

(defn setup-mfa [code]
  (let [remove-code #(>evt [:authentication/mfa-remove-code])
        help? (r/atom false)
        new? (r/atom false)
        show-help #(reset! help? true)
        hide-help #(reset! help? false)
        no-authy #(reset! new? true)
        have-authy #(reset! new? false)]
    (fn []
      (if-not @help?
        ;; Initial setup
        [:div
         [mfa-header {:title "Set up two-factor authentication"
                      :text "Greatly increase security by requiring both your password and another form of authentication."}]
         [step-grid-s
          [mfa-step {:number "1."
                     :title "Download Authy on your mobile device"}
           [typo/text {:line-height "1.875rem"
                       :text-align "center"
                       :max-width "25rem"} "Authy helps you access and generate 6 digit codes that you can use to authenticate.  Google Authenticator is a valid alternative."]
           [badge-s {:href "https://authy.com/"
                     :target "_blank"
                     :logo "authy"
                     :margin "4.375rem 0"}]
           [badge-s {:href "https://play.google.com/store/apps/details?id=com.authy.authy"
                     :target "_blank"
                     :logo "google"}]
           [badge-s {:href "https://itunes.apple.com/us/app/authy/id494168017"
                     :target "_blank"
                     :logo "apple"}]
           [form/naked-button-s {:on-click show-help
                                 :font-size "0.88rem"} "Further instruction on how to set up Authy"]]
          [mfa-step {:number "2."
                     :title "Use Authy to scan this QR code"}
           [qr-code-s {:src code}]]

          [mfa-step {:number "3."
                     :title "Now you're ready to enter your 6-digit authentication code"}
           [form/button {:on-click remove-code} "Next"]]]]

        ;; Help screen
        [:div
         [mfa-header {:title "Setting up Authy"}]
         [back-button-s {:on-click hide-help} "Back"]
         [common/grid-s {:grid-template-columns "minmax(1rem, 20rem) minmax(1rem, 20rem)"
                         :justify-content "center"
                         :margin "0 0 3.75rem"}
          [help-tab-s {:on-click have-authy
                       :active? (false? @new?)} "I already have Authy"]
          [help-tab-s {:on-click no-authy
                       :active? (true? @new?)} "I am new to Authy"]]
         (if-not @new?
           ;; Help tab 1
           [step-grid-s
            [mfa-step {:number "1."
                       :title "Open the main screen of the Authy app, choose 'add account' from the menu"}
             [authy-screen-s {:src "/assets/2fa/authy--have-1.png"}]]
            [mfa-step {:number "2."
                       :title "Choose 'scan QR code'"}
             [authy-screen-s {:src "/assets/2fa/authy--have-2.png"}]]
            [mfa-step {:number "3."
                       :title "Scan the QR code with your cell phone camera and continue to the final step"}
             [authy-screen-s {:src "/assets/2fa/authy--have-3.png"}]
             [form/button {:on-click hide-help} "View QR code"]]]
           ;; Help tab 2
           [step-grid-s
            [mfa-step {:number "1."
                       :title "Download Authy on your mobile device"}
             [badge-s {:href "https://authy.com/"
                       :target "_blank"
                       :logo "authy"
                       :margin "2rem 0 4rem"}]
             [badge-s {:href "https://play.google.com/store/apps/details?id=com.authy.authy"
                       :target "_blank"
                       :logo "google"}]
             [badge-s {:href "https://itunes.apple.com/us/app/authy/id494168017"
                       :target "_blank"
                       :logo "apple"}]]
            [mfa-step {:number "2."
                       :title "Setup Authy and choose a method to verify your account"
                       :grid-column "span 2"}
             [common/grid-s {:grid-template-columns "1fr 1fr"
                             :grid-gap "5rem"}
              [authy-screen-s {:src "/assets/2fa/authy--new-1.png"}]
              [authy-screen-s {:src "/assets/2fa/authy--new-2.png"}]]]
            [mfa-step {:number "3."
                       :title "Verify your account"
                       :grid-column "span 2"}
             [common/grid-s {:grid-template-columns "1fr min-content 1fr"
                             :grid-gap "2.5rem"
                             :position "relative"
                             :align-items "center"}
              [:div
               [step-title-s {:font-weight "400"
                              :margin "0 0 -1rem"} "Via phone call"]
               [authy-screen-s {:src "/assets/2fa/authy--new-3.png"}]]
              [abs-label-s "Or"]
              [:div
               [step-title-s {:font-weight "400"
                              :margin "0 0 -1rem"} "Via SMS"]
               [authy-screen-s {:src "/assets/2fa/authy--new-4.png"}]]]]
            [mfa-step {:number "4."
                       :title "Create a backup password"}
             [authy-screen-s {:src "/assets/2fa/authy--new-5.png"}]]
            [mfa-step {:number "5."
                       :title "Add an account"}
             [authy-screen-s {:src "/assets/2fa/authy--new-6.png"}]]
            [mfa-step {:number "6."
                       :title "Choose 'scan QR code'"}
             [authy-screen-s {:src "/assets/2fa/authy--new-7.png"}]]
            [mfa-step {:number "7."
                       :title "Capture QR code with your cell phone camera and continue to final step"}
             [authy-screen-s {:src "/assets/2fa/authy--new-8.png"}]
             [form/button {:on-click hide-help} "View QR code"]]])]))))

(defstyled input-wrapper-s :div
  {:display "flex"
   :flex-direction "column"
   :align-items "center"})

(defstyled mfa-sad-s :div
  {:color vars/red
   :font-weight "bold"
   :margin-top "2rem"
   :font-size "1.25rem"})


(defn mfa []
  (let [state (r/atom {})
        mfa (rf/subscribe [:authentication/mfa])
        on-submit #(>evt [:authentication/verify-mfa %])]
    (fn []
      (let [{:keys [code error? failure?]} @mfa]
        [unauth-s
         [unauth-header]
         [mfa-wrapper-s
          [mfa-s
           (if code
             [setup-mfa code]
             [:form
              {:on-submit (fn [evt]
                            (.preventDefault evt)
                            (on-submit @state))}
              [mfa-header {:title "Log in with two-factor authentication"
                           :text "Enter the 6-digit authentication code provided by Authy"}]
              [input-wrapper-s
               [form/input {:name :otp-token
                            :auto-complete "off"
                            :on-change #(swap! state get-input-val :otp-token %)
                            :placeholder "000000"}]
               [form/button {:type "submit"
                             :width "22rem"
                             :margin "2rem 0 0"
                             :grid-row "2"
                             :data-test "verify-code-submit"} "Verify Code"]
               (when error?
                 [mfa-sad-s "There was an error with your code. Please try again."])
               (when failure?
                 [mfa-sad-s "There was an problem processing your request. Please try again in a few minutes."])]])]]
         [unauth-footer]]))))

(defn reset-password []
  (let [state (r/atom {:error false})
        form-s (rf/subscribe [:authentication/form])
        do-reset-password (fn []
                            (swap! state #(assoc % :error false))
                            (>evt [:set-password @state]))]
    (fn []
      [unauth-s
       [unauth-header]
       [form-wrapper-s
        [form-subtitle-s "Need a new password?"]
        [form-title-s "Set your new password"]
        [:form
         {:on-submit (fn [evt]
                       (.preventDefault evt)
                       (if (valid-password? (:password @state))
                         (do-reset-password)
                         (swap! state #(assoc % :error true))))}
         [message @form-s]

         [form-item-s
          [password-reveal #(do
                              (swap! state get-input-val :password %)
                              (swap! state assoc :error false))]]

         (if (:error @state)
           [message-s {:error? true} "Password does not meet the complexity requirements:"])

         [password-complexity-requirements]
         [form/button {:type "submit"
                       :disabled (:submitting? @form-s)} "Reset Password"]]]
       [unauth-footer]])))

(defn forgot-password []
  (let [state (r/atom {})
        form-s (rf/subscribe [:authentication/form])
        partner (rf/subscribe [:partner])
        on-submit #(>evt [:request-password-reset %])]
    (fn []
      [unauth-s
       [unauth-header]
       [form-wrapper-s
        [form-subtitle-s "Forgot password?"]
        [form-title-s "Reset your password"]
        [:form
         {:on-submit (fn [evt]
                       (.preventDefault evt)
                       (on-submit @state))}
         [help-text-s "Please enter your email address. You will receive a link to create a new password via email."]
         [message @form-s]
         [form-item-s
          [form/input {:name "email"
                       :required true
                       :on-change #(swap! state get-input-val :email %)
                       :placeholder "Email"
                       :type "email"
                       :data-test "forgot-password-input-email"}]]
         [form/button {:type "submit"
                       :margin "0 0 2rem"
                       :disabled (:submitting? @form-s)
                       :data-test "forgot-password-submit"} "Get a new password"]
         [signup-help (:phone-number @partner)]]]
       [unauth-footer]])))

(defn login []
  (let [state (r/atom nil)
        form-s (rf/subscribe [:authentication/form])
        brand (rf/subscribe [:brand])
        partner (rf/subscribe [:partner])]
    (fn []
      [unauth-s
       [unauth-header]
       [form-wrapper-s
        [form-subtitle-s (:name @brand)]
        [form-title-s "Log in to your client dashboard."]
        [:form
         {:on-submit (fn [evt]
                       (.preventDefault evt)
                       (>evt [:log-in @state]))}
         [message @form-s]
         [form-item-s
          [form/input {:data-test "login-input-email"
                       :name "email"
                       :required true
                       :on-change #(swap! state get-input-val :email %)
                       :placeholder "Username"
                       :type "email"}]]
         [form-item-s
          [form/input {:data-test "login-input-password"
                       :name "password"
                       :required true
                       :on-change #(swap! state get-input-val :password %)
                       :placeholder "Password"
                       :type "password"}]
          [form/naked-button-s {:data-test "forgot-password-button"
                                :on-click #(>evt [:forgot-password])
                                :size "small"
                                :margin ".5rem"
                                :display "inline-block"
                                :type "button"}
           "Forgot password?"]]
         [form/button {:data-test "login-submit"
                       :type "submit"
                       :disabled (:submitting? @form-s)
                       :margin "0 0 2rem"} (if (:submitting? @form-s) "Logging in..." "Login")]
         [signup-help (:phone-number @partner)]]]
       [unauth-footer]])))
